import { get, post, url ,fetch} from '../http2'


class NewHome {
      // 底部链接
      @url("info/bottom")
      @get
      getLinks(){}
  
      //公共列表请求
      @url("/cnu/common/queryKeyList")
      @get
      queryKeyList() {}
  
      // 公共列表详情请求
      @url("/cnu/common/queryListByKey")
      @get
      queryListByKey() {}
  
      // 查询课程中台筛选部分
      @url("/cnu/common/queryLabelList")
      @get
      queryLabelList() {}
  
      // 登录
      // @url("/yun/auth/user/login")
      @url("/s/auth/user/login")
      @post
      login() {}
  
      // // 登出
      // @url("/s/auth/user/logout")
      // @get
      // logout() {}
  
      // 手机号登录
      // @url("/yun/auth/user/loginByPhone")
      @url("/s/auth/user/loginByPhone")
      @post
      loginByPhone() {}
  
      // 验证手机验证码
      // @url("/yun/auth/user/phone/send_code")
      @url("/s/auth/user/phone/send_code")
      @post
      getVerifyCode() {}
  
      // 验证手机验证码
      // @url("/yun/auth/user/phone/check")
      @url("/s/auth/user/phone/check")
      @post
      checkCode() {}
  
      // 查询个人信息
      // @url("/yun/auth/user/info")
      @url("/s/auth/user/info")
      @get
      userInfo() {}
  
      // 获取融合教学列表
      // @url("/yun/course/teach/courseCloud/openList")
      @url("/s/course/course/auth/homeFuse")
      @get
      getFuseList() {}
  
      // 获取评价诊断列表
      // @url("/yun/course/teach/courseCloud/openList")
      @url("/s/course/course/auth/homeEvaluate")
      @get
      getEvaluateList() {}
  
      // 查询课程列表
      // @url("/yun/course/teach/courseCloud/openList")
      @url("/s/course/teach/courseCloud/openList")
      @get
      getCourseList() {}
  
      // 查询课程详情
      // @url("/yun/course/teach/courseCloud/openDetail")
      @url("/s/course/teach/courseCloud/openDetail")
      @get
      getCourseDetail() {}
  
      // 查询课节列表
      // @url("/yun/course/teach/courseCloud/openDetail")
      @url("/s/course/teach/courseCloud/openLesson")
      @get
      getCourseLesson() {}
  
      // 查询视频课节信息
      // @url("/yun/course/teach/courseCloud/openDetail")
      @url("/s/course/teach/lesson/getLessonById/")
      @fetch
      getLessonInfo() {}
      
      // 查询课程视频
      @url("/s/course/teach/lesson/getLessonVideoUrl/")
      @fetch
      getLessonVideoUrl() {}
  
       //教师列表
       @url("tea/list")
       @get
       gettealist(){}
   
       //教师详情
       @url("tea/one")
       @get
       getteadetail(){}
  
      //新闻列表
      @url("/news/list") //clazz 1.头条新闻 2.综合新闻 3.专题新闻
      @get
      GetNewsList(){}
  
      //新闻详情
      @url("/news/one") //
      @get
      GetNewsDetail(){}
  
      //最新推荐
      @url("/news/recommend") //
      @get
      GetNewsRecommend(){}
  
      //上下条信息
      @url("/news/near")
      @get
      GetNear(){}
      
      // 第三方接口请求
      @url("/s/auth/third/getAuthKey")
      @get
      getAuthKey(){}
 
}

export default new NewHome()
